import "./scss/main.scss";
import Appbar from "./components/appbar/appbar";
import Sidebar from "./components/sidebar/sidebar";
import {MeupCommonOptions} from "./model/meup-common-options";
import {authorizationService} from "./services/authorization.service";

let sidebar: Sidebar;
let appbar: Appbar;

export const init = (options?: MeupCommonOptions): { sidebar: Sidebar, appbar: Appbar } => {
    options = options ?? {};

    sidebar = new Sidebar();
    appbar = new Appbar();
    sidebar.setOptions(options, {
        onVisibilityChange: (is_visible) => appbar.refreshMenuButtonState(is_visible)
    });
    appbar.setOptions(options, {
        onMenuButtonClick: () => sidebar.toggle()
    })
    return {sidebar, appbar};
}

export const setMembership = (memberships: string[]): void => {
    authorizationService.parseMemberships(memberships);
    sidebar?.refreshAfterUserRoleAndStatutUpdate();
    appbar?.refreshAfterUserRoleAndStatutUpdate();
}
export const setTitle = (title: string): void => {
    appbar?.setTitle(title);
}


const initRef = init;
const setMembershipRef = setMembership;
const setTitleRef = setTitle;


// eslint-disable-next-line @typescript-eslint/no-namespace
export class MEUPCommon {
    init(options?: MeupCommonOptions): { sidebar?: Sidebar, appbar?: Appbar } {
        return initRef(options);
    }

    setMembership(memberships: string[]): void {
        return setMembershipRef(memberships);
    }

    setTitle(title: string): void {
        return setTitleRef(title);
    }
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export class MEUPCommonInjector {
    injectScript(base_url: string): Promise<void> {
        return Promise.resolve();
    }
}
